import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available        
        if (localStorage.getItem('auth_token') && request) {
            //console.log('Intercept Request:', request);
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                }
            });
        }

        return next.handle(request);
    }
}